export enum Mode {
  Activation = 'app/activation',
  FederatedSignIn = 'login',
  FederatedSignOut = 'signout',
  Callback = 'callback',
}
